import { Flex, Text } from 'components'

export default function ResultsPage() {
  return (
    <Flex direction="column" gap={4} flex="auto" mb={2} p={{ base: 4, sm: 0 }} overflowY="auto">
      <Text textStyle="h2" p={2} pt={7}>
        Results Page
      </Text>
    </Flex>
  )
}
